export default function (context) {
  if (!context.store.getters['user/isAdmin']) context.redirect('/')
}
